import { getHttpClient } from '@/services/http';
import type { CurrentUser } from '@/types/auth';

export interface SessionResponse {
  user: CurrentUser;
  token: string | null;
}

/**
 * Auth endpoint wrappers. Token comes back in the custom `bearer` response
 * header (matches legacy `api.js#logIn`), so we read the raw axios response
 * rather than going through `http<T>()` which unwraps `response.data`.
 */
export const sessionsApi = {
  async logIn(email: string, password: string): Promise<SessionResponse> {
    const response = await getHttpClient().request<CurrentUser>({
      url: 'sessions',
      method: 'post',
      data: { email, password },
    });
    return { user: response.data, token: readBearer(response.headers) };
  },
  async remoteLinkLogIn(key: string): Promise<SessionResponse> {
    const response = await getHttpClient().request<CurrentUser>({
      url: 'remote_link_sessions',
      method: 'get',
      params: { key },
    });
    return { user: response.data, token: readBearer(response.headers) };
  },
};

function readBearer(headers: unknown): string | null {
  if (!headers || typeof headers !== 'object') return null;
  const record = headers as Record<string, unknown>;
  const raw = record['bearer'] ?? record['Bearer'];
  return typeof raw === 'string' ? raw : null;
}
